/**
 * Removes all trailing forward-slash characters from a string.
 * Uses a linear-time backward scan instead of regex to avoid
 * ReDoS (super-linear backtracking) vulnerabilities.
 */
export function trimTrailingSlashes(value: string): string {
  let end = value.length;
  while (end > 0 && value[end - 1] === "/") {
    end--;
  }
  return value.slice(0, end);
}
